import { PokemonType } from "../types/pokemon";

const TYPE_TRANSLATIONS: Record<PokemonType, string> = {
  normal: "Normal",
  fire: "Feu",
  water: "Eau",
  electric: "Electrik",
  grass: "Plante",
  ice: "Glace",
  fighting: "Combat",
  poison: "Poison",
  ground: "Sol",
  flying: "Vol",
  psychic: "Psy",
  bug: "Insecte",
  rock: "Roche",
  ghost: "Spectre",
  dragon: "Dragon",
  dark: "Tenebres",
  steel: "Acier",
  fairy: "Fee",
};

export function translateType(type: string): string {
  return TYPE_TRANSLATIONS[type as PokemonType] ?? type;
}

const TYPE_COLORS: Record<PokemonType, string> = {
  normal: "#A8A77A",
  fire: "#EE8130",
  water: "#6390F0",
  electric: "#F7D02C",
  grass: "#7AC74C",
  ice: "#96D9D6",
  fighting: "#C22E28",
  poison: "#A33EA1",
  ground: "#E2BF65",
  flying: "#A98FF3",
  psychic: "#F95587",
  bug: "#A6B91A",
  rock: "#B6A136",
  ghost: "#735797",
  dragon: "#6F35FC",
  dark: "#705746",
  steel: "#B7B7CE",
  fairy: "#D685AD",
};

export function getTypeColor(type: string): string {
  return TYPE_COLORS[type as PokemonType] ?? "#777";
}
